import { ROOT } from 'navigation';
import { Redirect, Route, Switch } from 'react-router-dom';
import { HOME, RootPage } from 'root-page';

const RootRouterConfig = () => (
  <Switch>
    <Redirect path={ROOT} exact to={HOME} />
    <Route path={ROOT}>
      <RootPage path={ROOT} />
    </Route>
  </Switch>
);
export default RootRouterConfig;
